<script setup lang="ts">
import { usePageOverlay } from '@composable';

const pageOverlay = usePageOverlay();
const layers = computed(() => pageOverlay.Layers);

const router = useRouter();
const route = useRoute();
const back = ref<string | null | undefined>();

watch(
    () => route.fullPath,
    () => {
        back.value = router.options.history.state.back as string;
    }
);
onBeforeRouteUpdate((to, _from, next) => {
    if (to.fullPath === back.value && layers.value.length) {
        pageOverlay.closeLastLayer();
        next(false);
    } else {
        pageOverlay.closeAll();
        next();
    }
});
</script>

<template>
    <Teleport to="body">
        <div v-if="layers.length" class="page-overlay">
            <component
                :is="component"
                v-for="{ component, close, error, id, props } in layers"
                v-bind="props"
                :key="id"
                @close="
                    () => {
                        close();
                        props?.onClose();
                    }
                "
                @error="error"
            />
        </div>
    </Teleport>
</template>

<style lang="scss" scoped>
.page-overlay {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 99999999;
}
</style>
